import { render, staticRenderFns } from "./YearCalendarItem.vue?vue&type=template&id=9063321c&scoped=true&"
import script from "./YearCalendarItem.vue?vue&type=script&lang=js&"
export * from "./YearCalendarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9063321c",
  null
  
)

export default component.exports